import React from 'react';
import { List, ListItem } from '@andes/list';
import { shape, string, arrayOf } from 'prop-types';
import classNames from 'classnames';

const namespace = 'ui-pdp-credit-offer-list';
const DEFAULT_OPTIONS = [];

const CreditOfferList = ({ options = DEFAULT_OPTIONS, className = '' }) => {
  if (!options || options.length === 0) {
    return null;
  }

  return (
    <List
      className={classNames(namespace, className)}
      id="credit-offer-list"
      srLabel="opciones de credito"
      selectable={false}
    >
      {options.map(({ title, subtitle }) => (
        <ListItem title={title.text} description={subtitle.text} key={title.text} />
      ))}
    </List>
  );
};

CreditOfferList.propTypes = {
  className: string,
  options: arrayOf(
    shape({
      title: string.isRequired,
      subtitle: string.isRequired,
    }),
  ),
};

export default CreditOfferList;
